import { FC } from "react"

import { Box, BoxProps, CircularProgress } from "@mui/material"

type ContentLoaderProps = Omit<BoxProps, "children">

const ContentLoader: FC<ContentLoaderProps> = ({
  minHeight = 240,
  display = "flex",
  justifyContent = "center",
  alignItems = "center",
  width = "100%",
  ...boxProps
}) => (
  <Box
    data-testid="content-loader"
    display={display}
    justifyContent={justifyContent}
    alignItems={alignItems}
    minHeight={minHeight}
    width={width}
    {...boxProps}
  >
    <CircularProgress />
  </Box>
)

export default ContentLoader
